import React, { useEffect } from 'react'
import useSWR from 'swr'
import { useTranslation } from 'react-i18next'

import Loader from 'components/ui/loader/Loader'
import categoriesLibrary from 'api/courses/categories'
import { paths } from 'routes/paths'
import { CourseSection } from '../CourseSection'

interface Props {
  search: string
  setIsLoading: (isLoading: boolean) => void
  setHasCourses: (hasCourses: boolean) => void
}

export const Folders: React.FC<Props> = ({
  search,
  setHasCourses,
  setIsLoading,
}) => {
  const { t } = useTranslation()
  const { data, isLoading } = useSWR(
    { key: 'categories-library', search },
    async (arg) =>
      categoriesLibrary({
        page: 1,
        perPage: 8,
        search: arg.search,
      })
  )

  useEffect(() => {
    if (
      data?.premieres.count ||
      data?.folders.some((folder) => folder.courses.length)
    ) {
      setHasCourses(true)
    }
    setIsLoading(isLoading)
  }, [isLoading, data, setIsLoading, setHasCourses])

  const premieres = data?.premieres
  const premiereCourses = premieres?.courses
  return (
    <div style={{ display: 'flex', gap: '24px', flexDirection: 'column' }}>
      {!!premiereCourses && (
        <div>
          <CourseSection
            title={t('viewAll.title.premieres')}
            courses={premiereCourses}
            totalCourses={premieres.count || 0}
            href={paths.library.premieres}
          />
        </div>
      )}
      {data?.folders?.map((folder) => {
        if (!folder.courses.length) return null

        return (
          <div key={folder.id}>
            <CourseSection
              title={folder.name}
              courses={folder.courses}
              totalCourses={folder.coursesCount || 0}
              href={paths.library.folder.details(folder.id, folder.name)}
            />
          </div>
        )
      })}
      {isLoading && <Loader color />}
    </div>
  )
}
